import _ from "lodash";

import { isFailure } from "@sportal/api";
import {
  LOAD_SHARED_PROTECTIONS_SUCCESS,
  LOAD_SHARED_PROTECTIONS_FAILURE,
  ProtectionsActionTypes,
  SharedProtectionsSuccessPayload,
} from "./protections.types";
import { Protection } from "@sportal/api";
import { SBThunkAction } from "../redux.types";
import { NotificationActionTypes } from "../../components/notification";

export const loadSharedProtections =
  (): SBThunkAction<
    Promise<void>,
    ProtectionsActionTypes | NotificationActionTypes
  > =>
  async (dispatch, getState, { api }) => {
    const { config, protections } = getState();

    if (!_.isEmpty(protections.keys)) {
      return Promise.resolve();
    }

    const result = await api.ssm.protection.getSharedProtections();

    if (isFailure(result)) {
      dispatch(loadSharedProtectionsFailure(result.error));

      return Promise.reject(result.error);
    }

    const content = result.data.map(({ name, blocked }) => ({
      name,
      categories: blocked.map((cat) => ({ name: cat })),
    }));
    const enabledProtections = content.filter(
      (protection) => config.protections[protection.name]
    );
    const customProtection = _.find(content, {
      name: Protection.Custom,
    });
    const sortedProtections = _.sortBy(
      _.without(enabledProtections, customProtection),
      (protection) => protection.categories.length
    );
    const sharedProtections = _.map(
      [...sortedProtections, customProtection],
      (protection) => ({
        name: protection.name,
        categories: _.map(protection.categories, "name"),
      })
    );

    dispatch(loadSharedProtectionsSuccess(sharedProtections));
  };

export const loadSharedProtectionsSuccess = (
  sharedProtections: SharedProtectionsSuccessPayload
): ProtectionsActionTypes => ({
  type: LOAD_SHARED_PROTECTIONS_SUCCESS,
  payload: sharedProtections,
});
export const loadSharedProtectionsFailure = (
  error: object & { code: number | string }
): ProtectionsActionTypes => ({
  type: LOAD_SHARED_PROTECTIONS_FAILURE,
  payload: error,
});
